import { match as matchBrandRoute } from "@faire/web-api--source/routes/brand/brandToken/match";
export var isBrandPageRoute = function(pathname, search) {
    if (!pathname.endsWith("/")) {
        pathname += "/";
    }
    return matchBrandRoute("".concat(pathname).concat(search));
};
